var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.291,
    height: 59.928,
    viewBox: "0 0 76.291 59.928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_122547",
    "data-name": "Group 122547",
    transform: "translate(435.914 -22373.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171714",
    "data-name": "Path 171714",
    d: "M624.254,162.808c4.244-6.316,10.772-10.249,19.672-9.051,14.506,1.952,22.425,18.47,14.009,30.817-4.493,6.593-10.916,11.99-16.974,17.355-4.578,4.053-9.888,7.3-15.034,10.667-1.122.733-3.5,1.132-4.336.47-10.386-8.236-21.156-16.113-30.664-25.288-7.228-6.977-7.357-17-2.53-24.791,4.527-7.307,13.7-11.452,22.07-8.611,4.909,1.666,9.092,5.472,13.787,8.432",
    transform: "translate(-1021 22220)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.eb65e0a7531f7133f04b35a0ea9c8171.svg";
export { ForwardRef as ReactComponent };